export class ProjectOptions {
    projType: string;
    suDeploymentPath: string;
    boCode: string;
    suCode: string;
    appCode: string;
    boID: string;
    outputPath: string;
    conditionDebug: string;
    conditionRelease: string;
    targetFramework: string;
    packageName: string;
    nameSpace: string;
    name: string;
    description: string;
    path: string;
    type: string;
    attributes: any;
    override: boolean;
    codelanguage: string;
    processMode: string;
}
